/**
 * Stores a timestamp on every page switch in the local storage.
 * This is used to determine if the user has been inactive for a certain time.
 *
 * GLOBAL MIDDLEWARE - applied to all pages
 */
export default defineNuxtRouteMiddleware(() => {
    if (import.meta.client) {
        if (safeLocalStorage.isLocalStorageAccessible()) {
            try {
                safeLocalStorage.setItem('tot_last_interaction', zurichDate().toISOString());
            }
            catch (error) {

            }
        }
    }
});
